import axios from 'axios'
import config from '../config'

const getPageContentDetailApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}page/${params.slug}`,
        method: "get",
        headers: {
            "Content-Type": "application/json"
        }
    })
    return response

}

export default getPageContentDetailApi